import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function FavoriteButton({ listingId, variant = "icon", className = "" }) {
  const { user } = useAuth();
  const fav = useFavorites();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const active = !!fav && fav.isFavorite(listingId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user || user === false) {
      toast.info("Inicia sesión para guardar favoritos");
      navigate("/login");
      return;
    }
    if (busy) return;
    setBusy(true);
    const res = await fav.toggle(listingId);
    setBusy(false);
    if (res?.error) toast.error("No se pudo actualizar favoritos");
    else if (res?.favorited) toast.success("Guardado en tus favoritos");
  };

  if (variant === "pill") {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`h-12 px-4 rounded-xl border-2 inline-flex items-center justify-center gap-2 transition-colors ${
          active
            ? "bg-rose-50 border-rose-200 text-rose-700"
            : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"
        } ${className}`}
        data-testid={`favorite-btn-${listingId}`}
        aria-label={active ? "Quitar de favoritos" : "Guardar en favoritos"}
      >
        <Heart className={`w-5 h-5 ${active ? "fill-rose-600 text-rose-600" : ""}`} />
        <span className="text-sm font-medium">{active ? "En favoritos" : "Guardar"}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-9 w-9 rounded-full bg-white/95 backdrop-blur shadow-md grid place-items-center hover:scale-105 transition-transform ${className}`}
      data-testid={`favorite-btn-${listingId}`}
      aria-label={active ? "Quitar de favoritos" : "Guardar en favoritos"}
    >
      <Heart className={`w-4 h-4 ${active ? "fill-rose-600 text-rose-600" : "text-slate-700"}`} />
    </button>
  );
}
